module.exports = __webpack_public_path__ + "img/20190525110703QQ截图20190524163101.81475d8e.png";